import { useLanguage } from '../contexts/LanguageContext';

export default function LastUpdated() {
  const { language } = useLanguage();
  const date = new Date(__BUILD_DATE__);
  const formatted = date.toLocaleDateString(language === 'de' ? 'de-AT' : 'en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  });

  return (
    <p className="text-xs text-gray-400 dark:text-gray-500 text-center pt-4">
      {language === 'de' ? 'Zuletzt aktualisiert' : 'Last updated'}: {formatted}
    </p>
  );
}
